import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Element } from "react-scroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import ServiceTemp from "./ServiceTemp/Temp";
import BackgroundEffects from "../../UI/BackgroundEffects/BackgroundEffects";
import { services } from "../../../assets/text/ServiceText";
import classes from "./Services.module.css";

const Services = () => {
  const sectionRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"],
  });

  // Heading fades in with parallax scale
  const headingY = useTransform(scrollYProgress, [0, 0.3], [40, 0]);
  const headingOpacity = useTransform(scrollYProgress, [0, 0.25], [0, 1]);
  const headingScale = useTransform(scrollYProgress, [0, 0.3], [0.9, 1]);

  const containerVariants = {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.15 },
    },
  };

  return (
    <Element name="Services" className={classes.Services} ref={sectionRef}>
      <BackgroundEffects variant="skills" />
      <motion.div
        className={classes.ServiceHeadingWrapper}
      >
        <motion.h1
          className={classes.ServiceHeading}
          style={{ scale: headingScale }}
        >
          <FontAwesomeIcon icon={faGear} style={{ paddingRight: "15px" }} />
          My Services
        </motion.h1>
        <p className={classes.ServiceWriteup}>
          From concept to deployment, I offer end-to-end web solutions tailored
          to your needs — whether you need a stunning frontend, a rock-solid
          backend, a complete fullstack application, ongoing website
          administration, or one-on-one tutoring to level up your own skills.
        </p>
      </motion.div>

      <motion.div
        className={classes.ServiceList}
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.2 }}
      >
        {services.map((service, index) => (
          <ServiceTemp
            key={service.name}
            name={service.name}
            image={service.icon}
            description={service.desccription}
            index={index}
          />
        ))}
      </motion.div>
    </Element>
  );
};

export default Services;
